import React from 'react';
import ConversionMeasurementDatasetPanel from './ConversionMeasurementDatasetPanel';
import spendMeta1Raw from './spend_meta1_graph.csv?raw';

const ConversionMeasurementSpendTab: React.FC = () => (
    <ConversionMeasurementDatasetPanel rawCsv={spendMeta1Raw} dataset="spend" />
);

export default ConversionMeasurementSpendTab;
